<script setup>
import useSessionActions from '~/composables/sessions/useSessionActions';

const props = defineProps({
    session: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['close']);
const { isSaveSeatLoading } = useSessionActions(props.session);

const closeModal = () => {
    emit('close');
};
</script>

<template>
    <div>
        <h2>The session is at capacity</h2>
        <p class="modal-copy">Check back later to see if any seats have opened up!</p>
        <div class="modal-action-buttons">
            <ProjectButtonSecondary type="submit" :disabled="isSaveSeatLoading" :loading="isSaveSeatLoading"
                @click="closeModal" :filledIn="true">Close</ProjectButtonSecondary>
        </div>
    </div>
</template>
